module.exports = __WEBPACK_EXTERNAL_MODULE__opentelemetry_auto_instrumentations_web__;